import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "../lib/api";
import { Avatar } from "../lib/helpers";

export default function TeamPage() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);

  return (
    <div className="h-screen overflow-y-auto p-6 lg:p-10">
      <div className="flex items-center gap-3 mb-1">
        <Users className="h-6 w-6 text-primary" />
        <h1 className="font-display text-3xl font-extrabold">Equipo</h1>
      </div>
      <p className="text-zinc-500 mb-8">Colaboradores de @galletasaromaticas.com</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {users.map((u) => (
          <div key={u.id} data-testid={`team-member-${u.id}`} className="bg-[#121214] border border-white/10 rounded-xl p-5 flex items-center gap-4 hover:border-white/20 transition-colors animate-fade-up">
            <Avatar user={u} size={48} />
            <div className="min-w-0">
              <p className="font-semibold truncate">{u.name}</p>
              <p className="text-sm text-zinc-500 truncate">{u.email}</p>
              <span className={`inline-block mt-1.5 text-xs font-bold uppercase tracking-wider px-2 py-0.5 rounded ${u.role === "admin" ? "bg-primary/15 text-primary" : "bg-white/5 text-zinc-400"}`}>
                {u.role === "admin" ? "Administrador" : "Miembro"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
